module.exports = __webpack_public_path__ + "img/sqs.4a18f8dc.jpg";